import { Box } from '@mui/material';
import React from 'react';
import type { DocumentAsset } from '../../../services/admin/adminBackendServiceDocumentLibraryMixin';
import DocumentLibraryCard from './DocumentLibraryCard';
import DeleteConfirmBar from './DeleteConfirmBar';

interface MediaLibraryDocumentItemProps {
  doc: DocumentAsset;
  isNarrow: boolean;
  isDeletable: boolean;
  deleteMessage: string;
  confirming: boolean;
  deleting: boolean;
  deleteError: string | null;
  onRequestDelete: () => void;
  onCancelDelete: () => void;
  onConfirmDelete: () => void;
  onViewDocument: (externalId: string) => void;
}

/** One document card in the Documents tab's list, plus its inline delete-confirm bar when open. */
export default function MediaLibraryDocumentItem({
  doc,
  isNarrow,
  isDeletable,
  deleteMessage,
  confirming,
  deleting,
  deleteError,
  onRequestDelete,
  onCancelDelete,
  onConfirmDelete,
  onViewDocument,
}: MediaLibraryDocumentItemProps) {
  const handleCardClick = () => {
    if (doc.status === 'READY') {
      onViewDocument(doc.externalId);
    }
  };

  return (
    <Box sx={{ width: isNarrow ? undefined : '100%', minWidth: 0, flexShrink: 0 }}>
      <Box
        onClick={doc.status === 'READY' ? handleCardClick : undefined}
        sx={{ cursor: doc.status === 'READY' ? 'pointer' : undefined }}
      >
        <DocumentLibraryCard
          doc={doc}
          fluid={!isNarrow}
          // No onImport here: the wrapping Box above already makes the whole card
          // clickable to the same effect, so a separate icon would just be a
          // redundant use of the row's limited width.
          onDelete={isDeletable ? onRequestDelete : undefined}
        />
      </Box>
      {confirming && (
        <DeleteConfirmBar
          message={deleteMessage}
          deleting={deleting}
          error={deleteError}
          onCancel={onCancelDelete}
          onConfirm={onConfirmDelete}
        />
      )}
    </Box>
  );
}
